import { Archive, Zap } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function ArchiveTabs() {
  return (
    <Tabs defaultValue="tab-1">
      <TabsList className="border bg-background rounded-lg h-9.5 p-1 gap-1 shadow-xs">
        <TabsTrigger
          value="tab-1"
          className="hover:bg-accent text-muted-foreground data-[state=active]:hover:bg-primary/10 relative after:absolute after:inset-x-0 after:bottom-0 h-7 data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-none hover:text-foreground/70"
        >
          <Zap
            className="-ms-0.5 me-1.5 opacity-60"
            size={16}
            aria-hidden="true"
          />
          Active
        </TabsTrigger>
        <TabsTrigger
          value="tab-2"
          className="hover:bg-accent text-muted-foreground data-[state=active]:hover:bg-primary/10 relative after:absolute after:inset-x-0 after:bottom-0 h-7 data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-none hover:text-foreground/70"
        >
          <Archive
            className="-ms-0.5 me-1.5 opacity-60"
            size={16}
            aria-hidden="true"
          />
          Archived
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
